function bhbInit(){
  var root=document.getElementById('bhb'); if(!root) return;
  var FONT="@font-face{font-family:'OpenDyslexic';src:url('https://cdn.jsdelivr.net/npm/@fontsource/opendyslexic@5.2.6/files/opendyslexic-latin-400-normal.woff2') format('woff2');font-weight:400;}@font-face{font-family:'OpenDyslexic';src:url('https://cdn.jsdelivr.net/npm/@fontsource/opendyslexic@5.2.6/files/opendyslexic-latin-700-normal.woff2') format('woff2');font-weight:700;}";

  /* running total */
  var details=root.querySelectorAll('details[data-mins]');
  var minsEl=document.getElementById('bhb-mins'), barEl=document.getElementById('bhb-bar');
  function total(){var s=0;details.forEach(function(d){if(d.open)s+=parseInt(d.dataset.mins,10);});
    if(minsEl)minsEl.textContent=s; if(barEl)barEl.style.width=Math.round(s/95*100)+'%';}
  details.forEach(function(d){d.addEventListener('toggle',total);});
  total();

  /* print one sheet or every sheet: CSS handles the page, no markup in strings */
  function printSheets(ids){
    var els=[],keep=[],opened=[];
    ids.forEach(function(id){var el=document.getElementById(id); if(el) els.push(el);});
    if(!els.length) return;
    els.forEach(function(el){
      var n=el.parentNode;
      while(n&&n!==document.body){
        if(n.tagName==='DETAILS'&&!n.open){n.open=true;opened.push(n);}
        n.classList.add('bhb-keep');keep.push(n);n=n.parentNode;
      }
      el.classList.add('bhb-printtarget');
    });
    els[els.length-1].classList.add('bhb-printlast');
    document.body.classList.add('bhb-printing');
    var done=function(){document.body.classList.remove('bhb-printing');
      els.forEach(function(el){el.classList.remove('bhb-printtarget');el.classList.remove('bhb-printlast');});
      keep.forEach(function(k){k.classList.remove('bhb-keep');});
      opened.forEach(function(d){d.open=false;});};
    if(window.matchMedia){var mq=window.matchMedia('print');
      var h=function(m){if(!m.matches){done();if(mq.removeEventListener)mq.removeEventListener('change',h);}};
      if(mq.addEventListener)mq.addEventListener('change',h);}
    window.addEventListener('afterprint',done,{once:true});
    setTimeout(function(){window.print();},60);
  }
  function printEvery(){printSheets(['sheet0','sheet1','sheet2','sheet3','sheet4','sheet5','sheet6','sheet7']);}
  if(!document.documentElement.hasAttribute('data-bhb-wired')){
    document.documentElement.setAttribute('data-bhb-wired','1');
    document.addEventListener('click',function(e){
      var t=e.target&&e.target.closest?e.target.closest('[data-print],[data-bhb]'):null;
      if(!t) return;
      var p=t.getAttribute('data-print');
      if(p){printSheets([p]);return;}
      var a=t.getAttribute('data-bhb');
      if(a==='printall'){printEvery();}
      else if(a==='pdf'){downloadPrints();}
      else if(a==='openall'){actDetails().forEach(function(d){d.open=true;});}
      else if(a==='closeall'){actDetails().forEach(function(d){d.open=false;});}
    });
  }
  function downloadPrints(){
    var ids=['sheet0','sheet1','sheet2','sheet3','sheet4','sheet5','sheet6','sheet7'],parts=[];
    ids.forEach(function(id){
      var el=document.getElementById(id); if(!el) return;
      var c=el.cloneNode(true);
      c.querySelectorAll('.bhb-noprint,[data-print],.bhb-clearbtn,.bhb-drawfoot,.bhb-mkown,button').forEach(function(n){n.remove();});
      c.classList.add('bhb-printtarget');
      c.removeAttribute('style');
      c.querySelectorAll('[tabindex]').forEach(function(n){n.removeAttribute('tabindex');});
      parts.push(c.outerHTML);
    });
    if(!parts.length) return;
    var css='';
    document.querySelectorAll('style').forEach(function(s){css+=s.textContent+'\n';});
    var doc='<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Big Head Bob Academy · Unit 1 Lesson 1 · Printables</title><style>'+css+
      '@page{margin:.5in;}html,body{margin:0;background:#fff;}'+
      '#bhb .bhb-printtarget:last-child{page-break-after:auto;}'+
      '#bhb .bhb-feelcard,#bhb .bhb-feelcard:hover,#bhb .bhb-feelcard:focus,#bhb .bhb-feelcard:focus-within{transform:none !important;box-shadow:none !important;animation:none !important;background:#fff !important;}'+
      '#bhb .bhb-emo{animation:none !important;}'+
      '</style></head><body class="bhb-printing"><div id="bhb" class="bhb-keep">'+parts.join('')+'</div></body></html>';
    var w=window.open('','_blank');
    if(!w){alert('Please allow pop-ups for this page, then tap Save as PDF again.');return;}
    w.document.open(); w.document.write(doc); w.document.close();
    var fire=function(){try{w.focus();w.print();}catch(err){}};
    if(w.document.readyState==='complete') setTimeout(fire,700); else w.addEventListener('load',function(){setTimeout(fire,700);});
  }
  /* discussion cards: opening one answer box opens them all */
  var qSync=false;
  root.querySelectorAll('.bhb-qrail').forEach(function(rail){
    var ds=rail.querySelectorAll('details');
    ds.forEach(function(d){
      d.addEventListener('toggle',function(){
        if(qSync) return; qSync=true;
        ds.forEach(function(o){if(o!==d)o.open=d.open;});
        setTimeout(function(){qSync=false;},0);
      });
    });
  });

  function actDetails(){return root.querySelectorAll('#walkthrough details[data-mins]');}

  /* spinning seat circles */
  var ringA=document.getElementById('bhb-ringA'),ringB=document.getElementById('bhb-ringB'),
      wrapB=document.getElementById('bhb-wrapB'),lblA=document.getElementById('bhb-lblA'),
      seatNum=document.getElementById('bhb-seatnum'),seatMsg=document.getElementById('bhb-seatmsg'),
      spinBtn=document.getElementById('bhb-spin'),
      seatCount=8,seatA=null,seatB=null,spinning=false,spinT=null,countA=8,countB=0,usedA=[],usedB=[],fresh=false;
  function seatDots(ring,count,offset,picked){
    if(!ring) return;
    ring.querySelectorAll('.bhb-seat').forEach(function(d){d.remove();});
    var size=count>15?40:count>12?44:50;
    for(var i=0;i<count;i++){
      var ang=(i/count)*Math.PI*2-Math.PI/2, on=picked===i;
      var d=document.createElement('div');
      d.className='bhb-seat';
      d.textContent=offset+i+1;
      d.style.cssText='position:absolute;width:'+size+'px;height:'+size+'px;left:'+Math.round(50+Math.cos(ang)*41)+'%;top:'+Math.round(50+Math.sin(ang)*41)+'%;transform:translate(-50%,-50%) scale('+(on?1.2:1)+');border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:'+(size>44?18:16)+'px;background:'+(on?'#cb6ce6':'#fff')+';color:'+(on?'#fff':'#41485a')+';border:2px solid '+(on?'#cb6ce6':'#ecd6fa')+';transition:transform .3s ease;';
      ring.appendChild(d);
    }
  }
  function drawSeats(){
    var two=seatCount>18;
    countA=two?Math.ceil(seatCount/2):seatCount;
    countB=seatCount-countA;
    if(seatNum) seatNum.textContent=seatCount+' in circle';
    if(wrapB) wrapB.style.display=two?'flex':'none';
    if(lblA) lblA.style.display=two?'block':'none';
    seatDots(ringA,countA,0,seatA);
    if(two) seatDots(ringB,countB,countA,seatB); else if(ringB) seatDots(ringB,0,0,null);
  }
  function seatSay(){
    if(!seatMsg) return;
    if(spinning){seatMsg.textContent='Spinning…';return;}
    if(seatA==null){seatMsg.textContent='Everyone take a seat number.';return;}
    var leftN=Math.max(0,countA-usedA.length);
    var tail=fresh?' New round: everyone is back in.':(leftN>0?' '+leftN+' still to go.':' Everyone has shared.');
    seatMsg.textContent=(countB>0
      ? 'Circle 1: seat '+(seatA+1)+' · Circle 2: seat '+(countA+(seatB||0)+1)+'. You two share next!'
      : 'Seat '+(seatA+1)+', you share next!')+tail;
  }
  function setSeats(n){seatCount=Math.max(2,Math.min(36,n));seatA=null;seatB=null;usedA=[];usedB=[];fresh=false;drawSeats();seatSay();}
  function pickUnused(count,used){
    if(!count) return null;
    var last=used.length?used[used.length-1]:null;
    if(used.length>=count){used.length=0;fresh=true;}
    var pool=[];for(var i=0;i<count;i++){if(used.indexOf(i)<0&&!(count>1&&i===last))pool.push(i);}
    var v=pool[Math.floor(Math.random()*pool.length)];used.push(v);return v;
  }
  var less=document.getElementById('bhb-seatless'),more=document.getElementById('bhb-seatmore');
  if(less) less.addEventListener('click',function(){setSeats(seatCount-1);});
  if(more) more.addEventListener('click',function(){setSeats(seatCount+1);});
  if(spinBtn) spinBtn.addEventListener('click',function(){
    if(spinning) return;
    fresh=false;
    var endA=pickUnused(countA,usedA), endB=countB>0?pickUnused(countB,usedB):null,
        step=0, total=countA*2+endA;
    spinning=true; seatSay();
    clearInterval(spinT);
    spinT=setInterval(function(){
      step++;
      if(step>=total){clearInterval(spinT);spinning=false;seatA=endA;seatB=endB;drawSeats();seatSay();return;}
      seatA=step%countA; seatB=countB>0?step%countB:null; drawSeats();
    },55);
  });
  if(ringA){drawSeats();seatSay();}

  /* sorter: a word in the wrong column shakes and hops back */
  root.querySelectorAll('input.bhb-sortin[type=radio]').forEach(function(inp){
    var m=/^bhbw(\d+)([ab])$/.exec(inp.id||''); if(!m) return;
    var idx=parseInt(m[1],10), col=m[2];
    var wrong=(col==='a'&&idx>=6)||(col==='b'&&idx<6);
    if(!wrong) return;
    inp.addEventListener('change',function(){
      if(!inp.checked) return;
      var chip=root.querySelector('.bhbc'+idx+(col==='a'?'-pos':'-neg'));
      if(chip){chip.classList.add('bhb-shake');
        setTimeout(function(){chip.classList.remove('bhb-shake');},480);}
      setTimeout(function(){
        var back=document.getElementById('bhbw'+idx+'p');
        if(back) back.checked=true;
        var none=document.getElementById('bhbselnone');
        if(none) none.checked=true;
      },520);
    });
  });

  /* bookmark stickers: tap to add, drag to move, x to remove */
  var stickCard=document.getElementById('bhb-bmcard');
  function addSticker(glyph,xPct,yPct){
    if(!stickCard) return;
    var s=document.createElement('span');
    s.className='bhb-sticker';
    s.style.left=(xPct||50)+'%'; s.style.top=(yPct||42)+'%';
    s.style.transform='translate(-50%,-50%)';
    s.textContent=glyph;
    var x=document.createElement('button');
    x.type='button'; x.textContent='×'; x.setAttribute('aria-label','Remove sticker');
    x.addEventListener('click',function(ev){ev.stopPropagation();s.remove();});
    s.appendChild(x);
    s.addEventListener('pointerdown',function(ev){
      if(ev.target!==s) return;
      ev.preventDefault(); s.setPointerCapture(ev.pointerId); s.style.cursor='grabbing';
      var move=function(e){
        var r=stickCard.getBoundingClientRect();
        s.style.left=Math.max(4,Math.min(96,((e.clientX-r.left)/r.width)*100))+'%';
        s.style.top=Math.max(4,Math.min(96,((e.clientY-r.top)/r.height)*100))+'%';
      };
      var up=function(){s.style.cursor='grab';s.removeEventListener('pointermove',move);s.removeEventListener('pointerup',up);};
      s.addEventListener('pointermove',move); s.addEventListener('pointerup',up);
    });
    stickCard.appendChild(s);
  }
  var pal=document.getElementById('bhb-stickpal');
  if(pal) pal.addEventListener('click',function(e){
    var b=e.target.closest('[data-sticker]'); if(!b) return;
    addSticker(b.getAttribute('data-sticker'),40+Math.random()*20,30+Math.random()*30);
  });
  var bmClear=document.getElementById('bhb-bmclear');
  if(bmClear) bmClear.addEventListener('click',function(){
    if(!stickCard) return;
    var inner=stickCard.querySelector('.bhb-clearbtn');
    if(inner) inner.click();
    stickCard.querySelectorAll('.bhb-sticker').forEach(function(s){s.remove();});
  });

  /* share timer */
  var clock=document.getElementById('bhb-clock'),tStart=document.getElementById('bhb-tstart'),
      tReset=document.getElementById('bhb-treset'),left=180,tick=null;
  function paint(){if(clock)clock.textContent=Math.floor(left/60)+':'+('0'+(left%60)).slice(-2);}
  function stop(){if(tick){clearInterval(tick);tick=null;} if(tStart)tStart.textContent='Start';}
  if(tStart) tStart.addEventListener('click',function(){
    if(tick){stop();return;}
    tStart.textContent='Pause';
    tick=setInterval(function(){
      left--; paint();
      if(left<=0){stop();left=0;paint();if(clock){clock.textContent="Switch!";clock.style.color='#38b6ff';}}
    },1000);
  });
  if(tReset) tReset.addEventListener('click',function(){stop();left=180;if(clock)clock.style.color='#a84fd0';paint();});
  root.addEventListener('click',function(e){
    var b=e.target.closest('.bhb-tadj'); if(!b) return;
    left=Math.max(0,Math.min(3600,left+parseInt(b.getAttribute('data-tadj'),10)));
    if(clock)clock.style.color='#a84fd0';
    paint();
  });
  paint();

  /* keep the class's work through a refresh */
  var KEY='bhbL1:';
  function store(k,v){try{localStorage.setItem(KEY+k,v);}catch(err){}}
  function load(k){try{return localStorage.getItem(KEY+k);}catch(err){return null;}}
  root.querySelectorAll('input[type=text],textarea,input[type=number]').forEach(function(el,i){
    if(el.closest('#bhb-form')) return;
    var k='f'+i, saved=load(k);
    if(saved!==null&&saved!=='') el.value=saved;
    el.addEventListener('input',function(){store(k,el.value);});
  });
  root.querySelectorAll('form').forEach(function(f){
    f.addEventListener('reset',function(){setTimeout(function(){
      f.querySelectorAll('input[type=text],textarea').forEach(function(el){
        root.querySelectorAll('input[type=text],textarea,input[type=number]').forEach(function(e2,i){if(e2===el)store('f'+i,'');});
      });},0);});
  });

  /* box breathing: CSS drives the motion; JS only counts cycles */
  var dotEl=document.getElementById('bhb-dot'),cycEl=document.getElementById('bhb-cycles'),
      playEl=document.getElementById('bhb-play'),cycles=0;
  if(dotEl&&cycEl){dotEl.addEventListener('animationiteration',function(){cycles++;cycEl.textContent=cycles;});}
  if(playEl&&cycEl){playEl.addEventListener('change',function(){if(playEl.checked){cycles=0;cycEl.textContent='0';}});}

  /* drawable mood boxes */
  root.querySelectorAll('canvas.bhb-canvas').forEach(function(cv,ci){
    var ctx=cv.getContext('2d'); if(!ctx) return;
    var CK='cv'+ci, saved=load(CK);
    if(saved){var im=new Image();im.onload=function(){ctx.drawImage(im,0,0);};im.src=saved;}
    var save=function(){try{store(CK,cv.toDataURL('image/png'));}catch(err){}};
    ctx.lineWidth=3; ctx.lineCap='round'; ctx.lineJoin='round'; ctx.strokeStyle='#2a2e3a';
    var on=false;
    function pt(e){var r=cv.getBoundingClientRect();
      return {x:(e.clientX-r.left)*(cv.width/r.width),y:(e.clientY-r.top)*(cv.height/r.height)};}
    cv.addEventListener('pointerdown',function(e){on=true;try{cv.setPointerCapture(e.pointerId);}catch(err){}
      var p=pt(e);ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(p.x+0.1,p.y);ctx.stroke();e.preventDefault();});
    cv.addEventListener('pointermove',function(e){if(!on)return;var p=pt(e);ctx.lineTo(p.x,p.y);ctx.stroke();e.preventDefault();});
    ['pointerup','pointerleave','pointercancel'].forEach(function(ev){cv.addEventListener(ev,function(){if(on)save();on=false;});});
    var btn=document.createElement('button');
    btn.type='button'; btn.className='bhb-clearbtn'; btn.textContent='Clear drawing';
    btn.addEventListener('click',function(){ctx.clearRect(0,0,cv.width,cv.height);store(CK,'');});
    var box=cv.closest('.bhb-drawbox');
    var foot=box&&box.querySelector('.bhb-drawfoot');
    if(foot) foot.appendChild(btn); else if(box) box.appendChild(btn);
  });

  /* contact form: Shopify posts it and comes back with ?contact_posted=true */
  var form=document.getElementById("bhb-form"),wrap=document.getElementById("bhb-formwrap"),
      sentBox=document.getElementById("bhb-sent"),sentName=document.getElementById("bhb-sentname"),
      again=document.getElementById("bhb-again"),contact=document.getElementById("contact");
  function showContact(el){var d=contact&&contact.querySelector("details"); if(d) d.open=true;
    if(el) setTimeout(function(){el.scrollIntoView({behavior:"smooth",block:"center"});},150);}
  if(form) form.addEventListener("submit",function(){
    var el=form.elements["contact[name]"], n=el?(el.value||"").trim().split(" ")[0]:"";
    try{sessionStorage.setItem("bhbSentName",n||"friend");}catch(err){}
  });
  if(sentBox&&/[?&]contact_posted=true/.test(location.search)){
    var who="friend"; try{who=sessionStorage.getItem("bhbSentName")||who; sessionStorage.removeItem("bhbSentName");}catch(err){}
    if(sentName) sentName.textContent=who;
    if(wrap) wrap.style.display="none"; sentBox.style.display="block";
    /* tidy the address after a few seconds so analytics still sees contact_posted=true */
    setTimeout(function(){try{history.replaceState(null,"",location.pathname+"#contact");}catch(err){}},4000);
    showContact(sentBox);
  }else if(wrap&&wrap.getAttribute("data-bhb-error")){showContact(wrap);}
  if(again) again.addEventListener("click",function(){
    sentBox.style.display="none"; if(wrap) wrap.style.display="block"; if(form) form.reset();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bhbInit);}else{bhbInit();}
document.addEventListener('shopify:section:load',bhbInit);
